
import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

const PowerBILoader = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f4f6f8",
      }}
    >
      {/* Circular Loader */}
      <CircularProgress
        size={80}
        thickness={4}
        sx={{ color: "#39729b", mb: 2 }}
      />

      {/* Loading Text */}
      <Typography
        variant="h6"
        sx={{
          fontWeight: 500,
          color: "#333",
          mb: 1,
        }}
      >
        Loading Power BI Report...
      </Typography>

      {/* Subtext */}
      <Typography
        variant="body2"
        sx={{
          color: "#666",
          fontStyle: "italic",
        }}
      >
        Please wait while we prepare your insights
      </Typography>
    </Box>
  );
};

export default PowerBILoader;
